import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=156ea981&scoped=true&"
import script from "./TopicDetail.vue?vue&type=script&lang=js&"
export * from "./TopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=156ea981&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ea981",
  null
  
)

export default component.exports